export { default as titleTemplate } from './title.dot';



// WEBPACK FOOTER //
// ./default-modules/ui/title/templates/index.ts